import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import {
    formatDate,
} from "../../utils";
import LeadCheckEmptyMobileDetail from "./indexDetail";
import { LeadCheckEmptyMobileProps } from "./indexDetail";
import { ApiClient} from "../../api/ApiClient";
import {
    IconModalStroked,
} from "@douyinfe/semi-icons";
import {
    Modal, Typography
} from '@douyinfe/semi-ui';

import React, { useEffect, useMemo, useState } from "react";

export default function LeadCheckEmptyMobile() {
    const [detailShow, setDetailShow] = useState(false);
  const [leadCheckEmptyMobileProps, setLeadCheckEmptyMobileProps] = useState(undefined as undefined | LeadCheckEmptyMobileProps);
const [crudApi, setCrudApi] = useState(
    undefined as undefined | CrudApi
  );
  const apiClient = ApiClient.getDefault();

    let cols: Col[] = [
      
        {
            name: "日期",
            key: "statDate",
            hideInList: false,
            showInFilter: false,
            type: ColType.STRING
        },
        {
            name: "检测时间",
            key: "updatedAt",
            showInFilter: true,
            hideInList: true,
            type: ColType.DATE_RANGE
        },
       
        {
            name: "客户姓名",
            key: "leadName",
            showInFilter: true,
            hideInList: true,
            type: ColType.STRING
        },
        
         {
            name: "手机号",
            key: "leadMobile",
            showInFilter: true,
            hideInList: true,
            type: ColType.STRING
        },
         {
            name: "渠道",
            key: "source",
            showInFilter: true,
            hideInList: true,
            type: ColType.STRING
        },
         {
            name: "星级",
            key: "leadStar",
            showInFilter: true,
            hideInList: true,
            getOptions: () =>
                    Promise.resolve([
                      { label: "0星", value: "0", key: "0" },
                      { label: "1星", value: "1", key: "1" },
                      { label: "2星", value: "2", key: "2" },
                      { label: "3星", value: "3", key: "3" },
                      { label: "4星", value: "4", key: "4" },
                      { label: "5星", value: "5", key: "5" },
                    ]),
                  type: ColType.SELECT,
        },
        {
            name: "城市",
            key: "applyCity",
            showInFilter: true,
            hideInList: true,
             type: ColType.SELECT,
                  getOptions: () => apiClient.getDictAsOpts("city"),
        },
        {
            name: "总检测数",
            key: "totalCount",
            showInFilter: false,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Typography.Text
                        link
                        onClick={() => {
                            openLeadCheckEmptyMobileModal(
                                record.statDate
                            );
                        }}
                    >
                        {value}
                    </Typography.Text>
                );
            },
        },
        {
            name: "正常数",
            key: "normalCount",
            showInFilter: false,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Typography.Text
                        link
                        onClick={() => {
                            openLeadCheckEmptyMobileModal(
                                record.statDate,1
                            );
                        }}
                    >
                        {value}
                    </Typography.Text>
                );
            },
        },
        {
            name: "空号数",
            key: "emptyCount",
            showInFilter: false,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Typography.Text
                        link
                        onClick={() => {
                            openLeadCheckEmptyMobileModal(
                                record.statDate,2
                            );
                        }}
                    >
                        {value}
                    </Typography.Text>
                );
            },
        },
        {
            name: "沉默号数",
            key: "silentCount",
            showInFilter: false,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Typography.Text
                        link
                        onClick={() => {
                            openLeadCheckEmptyMobileModal(
                                record.statDate,3
                            );
                        }}
                    >
                        {value}
                    </Typography.Text>
                );
            },
        },
        {
            name: "风险号数",
            key: "riskCount",
            showInFilter: false,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Typography.Text
                        link
                        onClick={() => {
                            openLeadCheckEmptyMobileModal(
                                record.statDate,4
                            );
                        }}
                    >
                        {value}
                    </Typography.Text>
                );
            },
        },
        {
            name: "未知错误数",
            key: "errorCount",
            showInFilter: false,
            type: ColType.STRING,
            render: (value, record, index) => {
                return (
                    <Typography.Text
                        link
                        onClick={() => {
                            openLeadCheckEmptyMobileModal(
                                record.statDate,-1
                            );
                        }}
                    >
                        {value}
                    </Typography.Text>
                );
            },
        },
         
    ]
    const openLeadCheckEmptyMobileModal = async (
        statDate: string, checkResult?: number|undefined
    ) => {
         let queryParams = crudApi?.getQueryParams();
        let p: LeadCheckEmptyMobileProps = {
              statDate: statDate,
              checkResult: checkResult,
              ...queryParams,
             
            };
            setLeadCheckEmptyMobileProps(p);
        setDetailShow(true);
    };

    let nowDate = new Date();
    const initFilterValues = {
        //createdAt: [nowDate, nowDate],
    };

    let startDateStr = formatDate(nowDate);
    let endDateStr = formatDate(nowDate);
    const initParams = {
        //createdAt: startDateStr + "," + endDateStr,

    };

    return <>
        <Modal icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }} />} title={"空号检测明细"}
            fullScreen={true}
            headerStyle={{
                flexShrink: 0, // 关键属性 2：固定标题
                borderBottom: '1px solid var(--semi-color-border)'
            }}
            bodyStyle={{
                overflow: 'auto', // 关键属性 3：启用内容滚动
                flex: 1
            }}
            footer={null}
            hasCancel={false} onCancel={() => setDetailShow(false)} onOk={() => setDetailShow(false)}
            visible={detailShow}>
            <div><LeadCheckEmptyMobileDetail statDate={leadCheckEmptyMobileProps?.statDate} checkResult={leadCheckEmptyMobileProps?.checkResult}
            leadName={leadCheckEmptyMobileProps?.leadName} 
            leadMobile={leadCheckEmptyMobileProps?.leadMobile} 
             leadStar={leadCheckEmptyMobileProps?.leadStar} 
              source={leadCheckEmptyMobileProps?.source} 
               applyCity={leadCheckEmptyMobileProps?.applyCity}  
             />
            </div>
        </Modal>
        <Crud
            getCrudApi={(crudApi) => {
              setCrudApi(crudApi);
            }}
            canUpdate={false}
            canCreate={false}
            name="空号检测统计"
            entityKey="leadCheckEmptyMobileLog/statLeadCheckEmptyMobileByDate"
            initFilterValues={initFilterValues}
            initParams={initParams}
            pageSize={500}
            cols={cols}
        />
    </>
}